// extracted by mini-css-extract-plugin
module.exports = {"warningBanner":"WarningBanner-module-warning-banner","warningIcon":"WarningBanner-module-warning-icon"};